import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=235b131a&"
import script from "./PermissionList.vue?vue&type=script&lang=js&"
export * from "./PermissionList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionList.vue?vue&type=style&index=0&id=235b131a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports